/**
 * UserAvatar — Avatar reutilizable con iniciales y color determinista.
 * Reutiliza getInitials y getAvatarColor de calendarAvatars.
 */

import { getInitials, getAvatarColor } from '@/utils/calendarAvatars';

interface UserAvatarProps {
  userId: string | null | undefined;
  name?: string | null;
  /** Tamaño en píxeles del avatar (default 28) */
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZES = {
  sm: 'h-6 w-6 text-[10px]',
  md: 'h-7 w-7 text-xs',
  lg: 'h-9 w-9 text-sm',
} as const;

export function UserAvatar({ userId, name, size = 'md', className = '' }: UserAvatarProps) {
  const initials = name
    ? getInitials(name)
    : userId
      ? userId.slice(0, 2).toUpperCase()
      : '??';
  const bgColor = getAvatarColor(userId);

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full text-white font-semibold flex-shrink-0 ${SIZES[size]} ${bgColor} ${className}`}
      title={name || undefined}
      aria-hidden
    >
      {initials}
    </span>
  );
}
